<template>
  <div class="relative">
    <caas-button
      v-if="!walletStore.isConnected"
      @click="showWalletSelector = true"
      variant="primary"
      :loading="walletStore.isConnecting"
      size="small"
    >
      Connect Wallet
    </caas-button>

    <div v-else class="flex items-center space-x-2">
      <caas-button @click="walletStore.disconnect" variant="secondary" size="small">
        {{ formatAddress(walletStore.currentAccount?.address?.toStringLong()) }}
      </caas-button>
    </div>

    <!-- Vue Wallet Selector Modal -->
    <WalletSelector v-if="showWalletSelector" @close="showWalletSelector = false" />
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useWalletStore } from '@/stores/wallet';
  import WalletSelector from './WalletSelector.vue';

  const walletStore = useWalletStore();
  const showWalletSelector = ref(false);

  function formatAddress(address?: string) {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }
</script>
